import Table from "../../../component/table/Table";
import { selectError, selectisLoading, selectGiacenze } from "../../../features/giacenze/giacenzeSlice";
import { fetchGiacenze } from "../../../features/giacenze/giacenzeThunk";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchCompanies } from "../../../features/company/companyThunk";
const SubStructureGiacenze = () => {
    const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
    const columns = [
        { field: "name", headerName: "Name", width: 200 },
        { field: "tipo", headerName: "Tipo", width: 150 },
        { field: "lotto", headerName: "Lotto", width: 150 },
        { field: "um", headerName: "UM", width: 100 },
        { field: "displonibile", headerName: "Q.ta disponibile", width: 180 },
        { field: "data_ingresso", headerName: "Data ingresso", width: 180 },
        { field: "scadenza", headerName: "Data scadenza", width: 180 },
        { field: "stato", headerName: "Stato", width: 150 },
        { field: "azioni", headerName: "Azioni", width: 100, sortable: false }
    ];
    const dispatch = useDispatch()
    const giacenze = useSelector(selectGiacenze) || []
    const giacenzeLoading = useSelector(selectisLoading)
    const giacenzeError = useSelector(selectError)

useEffect(() => {
    dispatch(fetchGiacenze())
},[dispatch, selectSelectedCompany])

useEffect(() => {
dispatch(fetchCompanies())
},[])
const mappedData = giacenze.map((item) => ({
    id: item.id,
    name:item.name,
    tipo:item.tipo,
    lotto:item.lotto,
    um:item.um,
    displonibile:item.displonibile,
    data_ingresso:item.data_ingresso,
    scadenza:item.scadenza
}))
    return (
        <>
            <div className="pageTemplate">
                <Table
                data={mappedData?.length ? mappedData : []}
                columns={columns}
                navData={"structureGiacenze"}
                deleteFunctions={"deleteGiacenzaData"}
                />
            </div>
        </>
    );
};
export default SubStructureGiacenze;